import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs/operators';
import { selectPerformanceEvent } from '../../../store/selectors/pd.selectors';
import { RoutesName } from '../constants/routes-name';

/**
 * Prevents navigation to a page if no event is selected previously.
 * The selected event is not in the URL, so after a refresh it goes back to the list keeping the filters.
 */
export const selectedEventGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router);
  const listRoute = state.url.startsWith(`/${RoutesName.ORGANIZATION}`) ? RoutesName.ORGANIZATION : RoutesName.PROGRAM;

  return store.select(selectPerformanceEvent).pipe(
    take(1),
    map(event => (event?.eventId ? true : router.createUrlTree([listRoute], { queryParams: route.queryParams })))
  );
};
